import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notice"
}
const _hoisted_2 = { style: {"max-width":"80%"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon el-icon-warning red",
  style: {"margin-right":"5px"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 友情提醒：您已提交注销账号申请，平台将于 ")
const _hoisted_5 = { class: "red" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 为您完成注销；注销完成后，数据不可恢复且不能登录硅语平台；完成注销前您可随时撤销申请，不影响继续使用！ ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon el-icon-arrow-right",
  style: {"vertical-align":"middle"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_DeleteAccountModal = _resolveComponent("DeleteAccountModal")!
  const _component_DeleteConfirmModal = _resolveComponent("DeleteConfirmModal")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: _ctx.locale }, {
    default: _withCtx(() => [
      (_ctx.detectStatus === 1 && _ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.detectDeadline), 1),
              _hoisted_6
            ]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateState('showDetectAccountModal', true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.lang('account.remove.undoDetect')) + "  ", 1),
                _hoisted_7
              ]),
              _: 1
            }),
            _createElementVNode("i", {
              class: "el-icon el-icon-close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show = false))
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view),
      _createVNode(_component_DeleteAccountModal, {
        visible: _ctx.showDetectAccountModal,
        "destroy-id": _ctx.currentRole?.destroyId,
        "destroy-time": _ctx.currentRole?.destroyTime,
        days: _ctx.days,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateState('showDetectAccountModal', false))),
        onConfirm: _ctx.handleConfirm,
        onSuccess: _ctx.handleUndoDetect
      }, null, 8, ["visible", "destroy-id", "destroy-time", "days", "onConfirm", "onSuccess"]),
      _createVNode(_component_DeleteConfirmModal, {
        visible: _ctx.showConfirmDeleteModal,
        days: _ctx.days,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateState('showConfirmDetectModal', false))),
        onSuccess: _ctx.handleConfirmDetect
      }, null, 8, ["visible", "days", "onSuccess"])
    ]),
    _: 1
  }, 8, ["locale"]))
}